// Canonical membership-tier display names — single source of truth (web).
// The only four valid tiers. Rename here to rebrand a tier app-wide.
// Keep in sync with /app/mobile/src/lib/tiers.ts.
export const TIER_LABELS = {
  free: "Individual Free",
  plus: "Individual Plus",
  business: "Business",
  brand_partner: "Brand Partner",
};

// Canonical tagline + feature list per tier — the SINGLE source of truth for all
// membership literature (web upgrade page AND printable flyer). Edit here only.
// Keep in sync with /app/mobile/src/lib/tiers.ts (TIER_FEATURES).
export const TIER_FEATURES = {
  free: {
    tagline: "Create your profile and explore the Two Degrees community.",
    features: [
      "Full profile, portfolio and verification request",
      "Discover and browse events (view only, cannot RSVP or buy tickets)",
      "Community posts and Groups",
      "The Loop, view everyone's live photo feed (posting requires Plus)",
      "Two Degrees Store, shop official community merch",
      "The Press, read articles & newsletters and follow publishers (publishing requires Plus)",
      "Online now, see who's active in the community in real time",
      "Guided tours & launch alerts when new features go live",
      "Polls, vote on community questions and watch live results",
      "Daily Check-In, a 3-task daily checklist that earns reward points",
    ],
  },
  plus: {
    tagline: "Connect, attend events, and unlock real introductions and opportunities.",
    features: [
      "Everything in Free",
      "Connections, People to Meet and the Within Two Degrees feed",
      "1:1 chat, calls and messaging (edit & delete your sent messages)",
      "Matches and unlimited warm intros",
      "RSVP to events, purchase tickets and QR check-in",
      "Two Degrees Wallet, load funds, pay and send to members (ID verified)",
      "Opportunities, browse and apply",
      "Post Statuses and The Loop, share updates & photos that disappear at midnight",
      "Social Media Hub, plan, schedule & track posts to your own accounts",
      "The Press, publish articles & newsletters with one-click AI spelling & grammar check",
      "Learning (LMS), courses, lessons and live sessions",
      "Rewards, streaks and achievements (staff/employee accounts excluded)",
      "Individual Plus badge and early event access",
    ],
  },
  business: {
    tagline: "Run your organization — host, hire, bill and manage your team.",
    features: [
      "Everything in Individual Plus",
      "Business profile, portfolio & catalog",
      "Host events with waitlists, attendees, invoices & event history",
      "Post & manage jobs",
      "Team management with per-employee access levels (Tools / Setup)",
      "Team Chat — channels, DMs and calls",
      "Video calls with in-call chat, shared notes and screen share",
      "Accounting — invoicing, expenses and recurring invoices",
      "Receipt capture",
      "Financial reports — P&L, cash flow and expense summary",
      "People & Payroll with third-party HR & payroll integrations",
      "CRM, Projects, Docs & Recruiting, private to your business",
      "Two-way Calendar & Email sync (Google & Outlook)",
      "Social Media Hub — TikTok, Facebook, Instagram, LinkedIn & X",
      "Two Degrees Wallet float — accept Wallet payments from members",
      "Stripe Connect payouts & sales reports",
      "Tracked in the Partnerships CRM pipeline",
    ],
  },
  brand_partner: {
    tagline: "Partner with Two Degrees, reviewed & approved by our team.",
    features: [
      "Applies as a member; reviewed & approved",
      "Full member feature set",
      "Tracked in the Partnerships CRM pipeline",
      "Premium partnership positioning",
    ],
  },
};
